import React from "react";
import './Loader.css';
import {useLoader} from "src/contexts/LoaderContext";

const Loader: React.FC = () => {
    const {isMainLoaderVisible, mainLoaderText} = useLoader();

    return (
        <>
            {isMainLoaderVisible && <div className="loading-waiting-popup" id="LoadingWaitingPopup">
                <div className="loading-waiting-container">
                    <div className="loader"></div>
                    <p>{mainLoaderText}</p>
                </div>
            </div>}
        </>

    );
};

export default Loader;